export default {
  PAID: 'paid',
  UNPAID: 'initiated',
  ISSUED: 'issued',
  PENDING: 'pending',
  QUEUED: 'queued',
};
